import { useTranslation } from "react-i18next";

export default function ReparerenOfVervangen() {
  const { t } = useTranslation("kozijn-reparatie");

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-6 md:mb-8">
          {t("reparerenOfVervangen.h2")}
        </h2>
        <p className="font-geist text-base md:text-lg text-brand-text/70 leading-relaxed text-center mb-10 md:mb-14 max-w-[800px] mx-auto">
          {t("reparerenOfVervangen.intro")}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-[1100px] mx-auto mb-10 md:mb-14">
          {/* Repareren */}
          <div className="bg-white rounded-xl border border-brand-border p-6 md:p-8">
            <div className="w-10 h-10 rounded-full bg-brand-yellow flex items-center justify-center mb-4 md:mb-5">
              <i className="ri-tools-line text-brand-text text-lg w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="font-geist font-bold text-lg md:text-xl text-brand-text mb-3 md:mb-4">
              {t("reparerenOfVervangen.wanneerRepareren")}
            </h3>
            <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed">
              {t("reparerenOfVervangen.wanneerReparerenText")}
            </p>
          </div>

          {/* Vervangen */}
          <div className="bg-white rounded-xl border border-brand-border p-6 md:p-8">
            <div className="w-10 h-10 rounded-full bg-brand-text flex items-center justify-center mb-4 md:mb-5">
              <i className="ri-exchange-line text-white text-lg w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="font-geist font-bold text-lg md:text-xl text-brand-text mb-3 md:mb-4">
              {t("reparerenOfVervangen.wanneerVervangen")}
            </h3>
            <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed">
              {t("reparerenOfVervangen.wanneerVervangenText")}
            </p>
          </div>
        </div>

        {/* Kosten + ISDE */}
        <div className="max-w-[1100px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <div className="bg-white rounded-xl border border-brand-border p-6 md:p-8">
            <h4 className="font-geist font-bold text-base md:text-lg text-brand-text mb-2">
              {t("reparerenOfVervangen.kosten")}
            </h4>
            <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed mb-3">
              {t("reparerenOfVervangen.kostenText")}
            </p>
            <p className="font-geist text-sm text-brand-text/60">
              {t("reparerenOfVervangen.kostenNote")}
            </p>
          </div>

          <div className="bg-[#FFF9E0] border border-[#FFD600] rounded-xl p-6 md:p-8">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-[#FFD600] flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-coins-line text-brand-text text-sm w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div>
                <h4 className="font-geist font-bold text-base md:text-lg text-brand-text mb-2">
                  {t("reparerenOfVervangen.isde")}
                </h4>
                <p className="font-geist text-sm md:text-base text-brand-text/80 leading-relaxed mb-3">
                  {t("reparerenOfVervangen.isdeText")}
                </p>
                <a
                  href="/blog/isde-subsidie-2026/"
                  className="inline-flex items-center gap-1.5 font-geist font-semibold text-sm text-brand-text bg-[#FFD600] px-4 py-2 rounded-lg hover:bg-[#e6c100] transition-colors whitespace-nowrap"
                >
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                  {t("reparerenOfVervangen.isdeLink")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}